const timesheetCommonServicesName = "/Kardex";

export function timesheetKardexService (http) {    
    return {
        getPersonnelKardexAsync: async (personnelCode, startDate) => {
            var param = {
                personnelCode,
                startDate
            }
            return await http.post(timesheetCommonServicesName + "/GetPersonnelKardexAsync", param);
        }
    }
}
